import * as React from 'react';
import { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { getHardware } from '../../services/service'
import { useParams } from 'react-router-dom';
import { Card, CardContent, Container, Typography } from '@mui/material';
import dateFnsFormat from 'date-fns/format';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function HardwareDetail() {
    const params = useParams();
    const [hardwareData, setHardwareData] = useState({})
    const [notFound, setNotFound] = useState(false)

    useEffect(() => {
        getHardware(params.id).then((response) => {
            response.data["created_at"] = dateFnsFormat(new Date(response.data.created_at), 'MMMM d, yyyy - HH:mm')
            setHardwareData(response.data)
            console.log(response.data)
        }).catch((err) => {
            if (err.response.status === 404) {
                setNotFound(true)
            }
            console.log(err)
        })
    }, [])

    const CardHardware = (props) => {
        const { title, content, description } = props;
        const contentAsText = !!description ? "body1" : "h5"
        return (
            <Card sx={{ display: 'flex', backgroundColor: "#E7EBF0", boxShadow: "0 8px 20px -12px rgba(0,0,0,0.3)", }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <CardContent sx={{ flex: '1 0 auto' }}>
                        <Typography variant="subtitle1" color="text.secondary" component="div">
                            {title}
                        </Typography>
                        <Typography component="div" variant={contentAsText} sx={{ whiteSpace: 'pre-line' }}>
                            {content}
                        </Typography>
                    </CardContent>
                </Box>
            </Card>
        )
    }

    return (
        !!notFound
            ? (
                <Typography variant={"h4"}>
                    {"Not Found"}
                </Typography>
            )
            : (
                hardwareData.name === undefined
                    ? null
                    : <Container style={{ padding: "20px 0px 50px 20px" }}>
                        <Row style={{ paddingTop: "20px" }}>
                            <Typography align="center" component="div" variant="h4">
                                Hardware - <strong>{hardwareData.name}</strong>
                            </Typography>
                        </Row>
                        <Row style={{ paddingTop: "20px" }}>
                            <Col lg={6}>
                                <CardHardware
                                    title={"Data de Criação"}
                                    content={hardwareData.created_at}
                                />
                            </Col>
                            <Col lg={6}>
                                <Card sx={{ display: 'flex', backgroundColor: "#E7EBF0", boxShadow: "0 8px 20px -12px rgba(0,0,0,0.3)", }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <CardContent sx={{ flex: '1 0 auto' }}>
                                            <Typography variant="subtitle1" color="text.secondary" component="div">
                                                {"Licença"}
                                            </Typography>
                                            <Typography component="div" variant={"h5"} sx={{ whiteSpace: 'pre-line' }}>
                                                {
                                                    !!hardwareData.bwise_license
                                                        ? <Link
                                                            style={{ textDecoration: 'none' }}
                                                            to={`/licenses/${hardwareData.bwise_license}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {"Acessar Licença "}<FaExternalLinkAlt />
                                                        </Link>
                                                        : "Não possui licença vinculada"
                                                }
                                            </Typography>
                                        </CardContent>
                                    </Box>
                                </Card>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "20px" }}>
                            <Col lg={12}>
                                <CardHardware
                                    title={"Chave do Hardware"}
                                    content={hardwareData.hardware_key}
                                    description={true}
                                />
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "20px" }}>
                            <Col lg={12}>
                                <CardHardware
                                    title={"Descrição da Licença"}
                                    content={hardwareData.description}
                                    description={true}
                                />
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "20px" }}>
                            <Typography align="center" component="div" variant="h4">
                                Modelo Hardware - <strong>{hardwareData.hardware_model.model}</strong>
                            </Typography>
                        </Row>
                        <Row style={{ paddingTop: "20px" }}>
                            <Col lg={4}>
                                <CardHardware
                                    title={"Fabricante"}
                                    content={hardwareData.hardware_model.manufacturer}
                                />
                            </Col>
                            <Col lg={4}>
                                <CardHardware
                                    title={"Memória RAM"}
                                    content={`${hardwareData.hardware_model.ram_size_gb} GB`}
                                />
                            </Col>
                            <Col lg={4}>
                                <CardHardware
                                    title={"Armazenamento"}
                                    content={`${hardwareData.hardware_model.disk_size_gb} GB`}
                                />
                            </Col>
                        </Row>

                        <Row style={{ paddingTop: "20px" }}>
                            <Typography align="center" component="div" variant="h6">
                                Especificações da CPU
                            </Typography>
                        </Row>
                        <Row style={{ paddingTop: "20px" }}>
                            <Col lg={3}>
                                <CardHardware
                                    title={"Modelo da CPU"}
                                    content={hardwareData.hardware_model.cpu_model}
                                />
                            </Col>
                            <Col lg={3}>
                                <CardHardware
                                    title={"Arquitetura da CPU"}
                                    content={hardwareData.hardware_model.cpu_arch}
                                />
                            </Col>
                            <Col lg={3}>
                                <CardHardware
                                    title={"Número de Núcleos da CPU"}
                                    content={hardwareData.hardware_model.cpu_cores}
                                />
                            </Col>
                            <Col lg={3}>
                                <CardHardware
                                    title={"Frequência da CPU"}
                                    content={`${hardwareData.hardware_model.cpu_frequency_ghz} GHz`}
                                />
                            </Col>
                        </Row>
                    </Container>
            )
    );
}